import React from 'react';
import { SvgCircleIcon, IconComponent, IconGlyphComponent } from '@shapeable/icons';

export const WaterwaysIcon: IconComponent = (props) => (
  <SvgCircleIcon { ...props } glyphWidth={96} glyphHeight={96}>

  </SvgCircleIcon>
);

export const WaterwaysIconGlyph: IconGlyphComponent = (props) => <WaterwaysIcon { ...props } variant='glyph' />;